import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

import { NgbActiveModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { EventManager, JhiLanguageService } from 'ng-jhipster';

import { AuthRequestBnbaccess } from './auth-request-bnbaccess.model';
import { AuthRequestBnbaccessPopupService } from './auth-request-bnbaccess-popup.service';
import { AuthRequestBnbaccessService } from './auth-request-bnbaccess.service';

@Component({
    selector: 'jhi-auth-request-bnbaccess-delete-dialog',
    templateUrl: './auth-request-bnbaccess-delete-dialog.component.html'
})
export class AuthRequestBnbaccessDeleteDialogComponent {

    authRequest: AuthRequestBnbaccess;

    constructor(
        private jhiLanguageService: JhiLanguageService,
        private authRequestService: AuthRequestBnbaccessService,
        public activeModal: NgbActiveModal,
        private eventManager: EventManager
    ) {
        this.jhiLanguageService.setLocations(['authRequest']);
    }

    clear () {
        this.activeModal.dismiss('cancel');
    }

    confirmDelete (id: number) {
        this.authRequestService.delete(id).subscribe(response => {
            this.eventManager.broadcast({
                name: 'authRequestListModification',
                content: 'Deleted an authRequest'
            });
            this.activeModal.dismiss(true);
        });
    }
}

@Component({
    selector: 'jhi-auth-request-bnbaccess-delete-popup',
    template: ''
})
export class AuthRequestBnbaccessDeletePopupComponent implements OnInit, OnDestroy {

    modalRef: NgbModalRef;
    routeSub: any;

    constructor (
        private route: ActivatedRoute,
        private authRequestPopupService: AuthRequestBnbaccessPopupService
    ) {}

    ngOnInit() {
        this.routeSub = this.route.params.subscribe(params => {
            this.modalRef = this.authRequestPopupService
                .open(AuthRequestBnbaccessDeleteDialogComponent, params['id']);
        });
    }

    ngOnDestroy() {
        this.routeSub.unsubscribe();
    }
}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/auth-request/auth-request-bnbaccess-delete-dialog.component.ts